/**
 * Finding one row among many, in a console that is used in Turkish.
 *
 * The fold is deliberately *not* Turkish casing. Correct Turkish lowercasing
 * maps `I` to `ı`, so typing `KIMENE` on an ASCII keyboard would stop matching
 * a session called `Kimene` — the rule that is right for rendering a word is
 * wrong for finding one. Every letter in the i-family collapses to `i`, and
 * diacritics are stripped, so `gorevler` finds `Görevler` and `setget` finds
 * `Setget` whichever keyboard is in front of the operator.
 *
 * It lived in `dashboardModel` until the tasks screen needed the same search
 * field. A rule shared by two screens belongs to neither of them.
 */

export function foldForSearch(value: string): string {
  return value
    .replace(/[\u0130I\u0131]/g, 'i')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

/** Whether any of `haystack` contains `query`, folded. An empty query matches
 *  everything: a search field nobody has typed into is not a filter. */
export function matchesQuery(haystack: Array<string | undefined>, query: string): boolean {
  const q = foldForSearch(query.trim())
  if (q === '') return true
  return haystack.some((v) => v && foldForSearch(v).includes(q))
}
